import { useHistory } from 'react-router-dom';
import { Link, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

import LoginSignUpBanner from 'pages/common/login-sign-up/login-sign-up-banner';

const useStyles = makeStyles(() => ({
  signup: { marginTop: '60px' },
  headingBox: { textAlign: 'center' },
}));

const Banner = () => {
  const classes = useStyles();
  const history = useHistory();

  return (
    <div className={classes.headingBox}>
      <LoginSignUpBanner />
      <div className={classes.signup}>
        <Typography variant="h4" style={{ marginBottom: '20px' }}>
          Create an Account
        </Typography>
        <Typography style={{ display: 'inline' }}>Already have an account?</Typography>{' '}
        <Typography style={{ display: 'inline', textDecoration: 'underline', cursor: 'pointer' }}>
          <Link onClick={() => history.push('/')} data-cy="sign-in-link">
            Log in
          </Link>
        </Typography>
      </div>
    </div>
  );
};

export default Banner;
